import { createSlice } from '@reduxjs/toolkit';

export const investigateSlice = createSlice({
  name: 'investigate',
  initialState: {
    // Cache alerts by ID for fast lookup
    alertsById: {},
    // Cache cluster stats by cluster name
    clusterStatsCache: {},
    // Track last fetch time for cache invalidation (optional)
    lastFetchTime: {}
  },
  reducers: {
    setAlertData: (state, action) => {
      const { alertId, data } = action.payload;
      state.alertsById[alertId] = data;
      state.lastFetchTime[`alert_${alertId}`] = Date.now();
    },
    setClusterStats: (state, action) => {
      const { clusterName, data } = action.payload;
      state.clusterStatsCache[clusterName] = data;
      state.lastFetchTime[`cluster_${clusterName}`] = Date.now();
    },
    clearAlertCache: (state, action) => {
      const { alertId } = action.payload;
      delete state.alertsById[alertId];
      delete state.lastFetchTime[`alert_${alertId}`];
    },
    clearClusterCache: (state, action) => {
      const { clusterName } = action.payload;
      delete state.clusterStatsCache[clusterName];
      delete state.lastFetchTime[`cluster_${clusterName}`];
    }
  }
});

export const { setAlertData, setClusterStats, clearAlertCache, clearClusterCache } = investigateSlice.actions;

export default investigateSlice.reducer;
